import { render, staticRenderFns } from "./ChatBoxDemanda.vue?vue&type=template&id=28109c1a&scoped=true"
import script from "./ChatBoxDemanda.vue?vue&type=script&lang=js"
export * from "./ChatBoxDemanda.vue?vue&type=script&lang=js"
import style0 from "./ChatBoxDemanda.vue?vue&type=style&index=0&id=28109c1a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28109c1a",
  null
  
)

export default component.exports